import heavyTruckIcon from '../assets/vehicle-map-icons/heavy-truck.png';
import mediumTruckIcon from '../assets/vehicle-map-icons/medium-truck.png';
import cargoVanIcon from '../assets/vehicle-map-icons/cargo-van.png';
import flatbedIcon from '../assets/vehicle-map-icons/flatbed.png';
import pickUpIcon from '../assets/vehicle-map-icons/pick-up.png';
import tricycleIcon from '../assets/vehicle-map-icons/tricycle.png';

export const VEHICLE_TYPES = Object.freeze([
  'Heavy Truck',
  'Medium Truck',
  'Cargo Van',
  'Flatbed',
  'Pick Up',
  'Tricycle',
]);

export const DEFAULT_VEHICLE_MAP_TYPE = 'Heavy Truck';
export const VEHICLE_MARKER_SCALE = 1.3;

export const VEHICLE_TYPE_ICON_CONFIG = Object.freeze({
  'Heavy Truck': Object.freeze({ icon: heavyTruckIcon, fileName: 'heavy-truck.png', outerScale: VEHICLE_MARKER_SCALE, innerScale: 1, markerOffsetX: 0 }),
  'Medium Truck': Object.freeze({ icon: mediumTruckIcon, fileName: 'medium-truck.png', outerScale: VEHICLE_MARKER_SCALE, innerScale: 1, markerOffsetX: 0 }),
  'Cargo Van': Object.freeze({ icon: cargoVanIcon, fileName: 'cargo-van.png', outerScale: VEHICLE_MARKER_SCALE, innerScale: 1, markerOffsetX: 0 }),
  Flatbed: Object.freeze({ icon: flatbedIcon, fileName: 'flatbed.png', outerScale: VEHICLE_MARKER_SCALE, innerScale: 1, markerOffsetX: 0 }),
  'Pick Up': Object.freeze({ icon: pickUpIcon, fileName: 'pick-up.png', outerScale: VEHICLE_MARKER_SCALE, innerScale: 1, markerOffsetX: 0 }),
  Tricycle: Object.freeze({ icon: tricycleIcon, fileName: 'tricycle.png', outerScale: VEHICLE_MARKER_SCALE, innerScale: 1, markerOffsetX: 0 }),
});

export const isCanonicalVehicleType = (value) => VEHICLE_TYPES.includes(value);

export const normalizeVehicleType = (value) => {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  const aliased = trimmed === 'Pickup' ? 'Pick Up' : trimmed;
  return isCanonicalVehicleType(aliased) ? aliased : null;
};

export const resolveVehicleMapType = (value) => (
  normalizeVehicleType(value) || DEFAULT_VEHICLE_MAP_TYPE
);

export const resolveVehicleMapIcon = (value) => (
  VEHICLE_TYPE_ICON_CONFIG[resolveVehicleMapType(value)].icon
);

export const resolveVehicleMarkerFraming = (value) => {
  const config = VEHICLE_TYPE_ICON_CONFIG[resolveVehicleMapType(value)];
  return { outerScale: config.outerScale, innerScale: config.innerScale, offsetX: config.markerOffsetX };
};

export const normalizeCourse = (value) => {
  if (value === null || value === undefined || value === '') return 0;
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return 0;
  return ((numeric % 360) + 360) % 360;
};
